import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async sendToConcierge(body: ApiSchemas['SendToConciergeDto']) {
    return wrapEndpoint(() =>
      client.POST('/concierge', {
        body,
        bodySerializer(body) {
          const fd = new FormData()

          if (body.physicianId !== undefined) fd.append('physicianId', String(body.physicianId))
          if (body.attendanceId !== undefined) fd.append('attendanceId', String(body.attendanceId))
          if (body.healthPlanId !== undefined) fd.append('healthPlanId', String(body.healthPlanId))
          if (body.patientName !== undefined) fd.append('patientName', body.patientName)
          if (body.patientPhone !== undefined) fd.append('patientPhone', body.patientPhone)
          if (body.observation !== undefined) fd.append('observation', body.observation)

          if (body.files && body.files.length > 0) {
            body.files.forEach((file, index) => {
              fd.append(`files.${index}`, file as unknown as File)
            })
          }

          return fd
        },
      }),
    )
  },
  async subscribeToConcierge(physicianId: number) {
    return wrapEndpoint(() =>
      client.PATCH('/concierge/subscribe/physician/{id}', {
        params: {
          path: {
            id: physicianId,
          },
        },
      }),
    )
  },
  async unsubscribeToConcierge(physicianId: number) {
    return wrapEndpoint(() =>
      client.PATCH('/concierge/unsubscribe/physician/{id}', {
        params: {
          path: {
            id: physicianId,
          },
        },
      }),
    )
  },
}
